import React, { useContext, useEffect } from 'react';
import styles from './Permissions.module.scss';
import { withRouter, useHistory } from 'react-router-dom';
import { PermissionsForm } from './components';
import {
	Header,
	PageContainer,
	Sidebar,
	SideMenu,
	Page,
	PageAuth,
	PageHeader,
	GlobalAlert,
	AccountActions,
	PERMISSIONS,
} from '../..';
import { debounce, profilePages, PROFILE_SETTINGS_URL, PropertyType, useStore } from '../../../common';
import { AuthContext } from '../../../logic';

export const PermissionsComponent = (props: PropertyType): JSX.Element => {
	const [, dispatch] = useStore(false);
	const { user, token } = useContext(AuthContext);
	const history = useHistory();
	const { id } = props.match.params;
	const isCurrentUser = user?.id === id;

	useEffect(() => {
		dispatch('USER_INIT', { token, id });
	}, [user, id]);

	const onUserSubmit = async () => {
		await dispatch('USER_SUBMIT', token);
		debounce(() => history.replace(`${PROFILE_SETTINGS_URL.value}/${id}`), 3000);
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canViewUser}>
				<PageContainer>
					<Sidebar dataId='account-sidebar' opened>
						<SideMenu options={profilePages} />
					</Sidebar>
					<Page>
						<PageHeader title='Permissions'>{!isCurrentUser ? <AccountActions /> : null}</PageHeader>
						<section className={styles.PageContent}>
							<PermissionsForm onSubmit={onUserSubmit} />
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

const Permissions = withRouter(PermissionsComponent);

export { Permissions };
